// breadcrumb.component.ts
import { Component, Injector, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CONFIG_CONTEXT } from 'src/app/enum/config-context.enum';
import { CurrentService } from 'src/app/services/current.service';
import { MODAL, ModalService } from 'src/app/services/modal.service';
import { TunnelService } from 'src/app/services/tunnel.service';
import { faHome } from '@fortawesome/free-solid-svg-icons';
import { CustomerService } from 'src/app/services/customer.service';

@Component({
  selector: 'ng-casto-breadcrumb',
  templateUrl: './breadcrumb.component.html',
})
export class BreadcrumbComponent implements OnInit {
  public readonly INSPIRATION: string = 'Inspiration';
  public readonly CONCEPTION: string = 'Conception';
  public readonly PLAN_DE_TRAVAIL: string = 'Plan de travail';
  public readonly RECAPITULATIF: string = 'Récapitulatif';
  public readonly FINANCEMENT: string = 'Financement';
  public readonly VALIDATION: string = 'Validation';

  @Input() currentPage: string;
  @Input() isUnlocked: boolean = false;

  public workbenchLoading: boolean = false;

  faHome = faHome;

  constructor(
    public currentService: CurrentService,
    public modalService: ModalService,
    public router: Router,
    public injector: Injector,
    public customerService: CustomerService
  ) {}

  get isCustomerSelect(): boolean {
    return this.customerService.userDatas != null;
  }

  ngOnInit(): void {
    if (this.isCurrentContextKitchen) {
      this.subscribeDataLoadingWorkbench();
    }
  }

  get currentContext(): string {
    return this.injector.get(CustomerService).context;
  }

  get isCurrentContextKitchen(): boolean {
    return this.currentContext === CONFIG_CONTEXT.KITCHEN;
  }

  //EN QUICK FIX, A REMANIER LORS DU REFACTO
  get isCurrentContextWorkbench(): boolean {
    return this.currentContext === CONFIG_CONTEXT.WORKBENCH;
  }

  get getUrlPath(): string {
    // TODO : il faudra faire quelque chose dans le ficher d'environnement
    switch (this.currentContext) {
      //EN QUICK FIX, A REMANIER LORS DU REFACTO
      case CONFIG_CONTEXT.WORKBENCH:
      case CONFIG_CONTEXT.KITCHEN:
        return 'cuisine';

      case CONFIG_CONTEXT.STORAGE:
        return 'rangements';

      case CONFIG_CONTEXT.BATHROOM:
        return 'salle-de-bain';
    }
    return '';
  }

  subscribeDataLoadingWorkbench() {
    this.injector.get(TunnelService).isDataLoading$.subscribe(isLoading => {
      this.workbenchLoading = isLoading;
    });
  }

  isBomLoaded(): boolean {
    return this.injector.get(TunnelService).kitchenTunnelData.bom !== undefined;
  }

  isOnWorkbench(): boolean {
    if (this.isCurrentContextKitchen) {
      return this.injector.get(TunnelService).currentContext === CONFIG_CONTEXT.WORKBENCH;
    }
    return false;
  }

  isWorkbenchCreated(): boolean {
    return this.injector.get(TunnelService).workbenchTunnelData.id !== undefined;
  }

  goToWorkbench() {
    this.modalService.display(MODAL.KITCHEN_TUNNEL_WORKBENCH_CHOICE, {});
  }

  showWarningModal(route: string, title: string, message: string, logout: boolean = false) {
    this.modalService.display(MODAL.MESSAGE, {
      titleRef: title,
      contentRef: message,
      buttons: [
        {
          labelRef: 'Oui',
          primary: true,
          action: () => {
            if (logout) {
              this.currentService.reset();
              this.injector.get(TunnelService).reset();
            }

            this.modalService.close();
            this.router.navigate([route]);
          },
        },
        {
          labelRef: 'Non',
          primary: false,
          action: () => {
            this.modalService.close();
          },
        },
      ],
    });
  }
}
